import React, { useState, useEffect } from "react";
import { IoMdRemoveCircle } from "react-icons/io";


const EditableField = ({ value, onChange }) => {
  const [val, setVal] = useState(value);

  useEffect(() => {
    setVal(value);
  }, [value]);

  const handleChange = (e) => {
    setVal(e.target.value);
    onChange(e.target.value);
  };

  return <input value={val} onChange={handleChange} className="border px-2 py-1 rounded" />;
};

const TreeNode = ({ data, onChange, path = [] }) => {
  const [newKey, setNewKey] = useState("");
  const [newValue, setNewValue] = useState("");

  const handleKeyChange = (e) => setNewKey(e.target.value);
  const handleValueChange = (e) => setNewValue(e.target.value);

  const handleAddField = () => {
    if (!newKey.trim()) return alert("Key cannot be empty");
    const updated = { ...data, [newKey]: newValue };
    onChange(updated);
    setNewKey("");
    setNewValue("");
  };

  const handleValueUpdate = (key, val) => {
    const updated = { ...data, [key]: val };
    onChange(updated);
  };

  const handleDeleteField = (key) => {
    const updated = { ...data };
    delete updated[key];
    onChange(updated);
  };

  return (
    <div className="ml-4">
      {Object.entries(data).map(([key, value]) => (
        <div key={[...path, key].join(".")} className="mb-2">
          <div className="font-semibold">{key}:</div>
          {typeof value === "object" && value !== null ? (
            <TreeNode
              data={value}
              onChange={(newVal) => {
                const updated = { ...data, [key]: newVal };
                onChange(updated);
              }}
              path={[...path, key]}
            />
          ) : (
        <div className="d-flex align-items-center">
  <div>
    <EditableField
      value={value}
      onChange={(val) => handleValueUpdate(key, val)}
    />
  </div>
  <div>
   <IoMdRemoveCircle role="button" size={22}  onClick={() => handleDeleteField(key)} className="text-danger"/>
  </div>
</div>
          )}
         
        </div>
      ))}
<div className="mt-2">
  <div className="mb-2">
    <input
      type="text"
      placeholder="New key"
      value={newKey}
      onChange={handleKeyChange}
      className="form-control"
    />
  </div>
  <div className="mb-2">
    <input
      type="text"
      placeholder="New value"
      value={newValue}
      onChange={handleValueChange}
      className="form-control"
    />
  </div>
  {/* <div>
    <MdAddCircle
      onClick={handleAddField}
      role="button"
      size={24}
      className="text-success"
      style={{ cursor: 'pointer' }}
    />
  </div> */}
<div className="text-end pb-2">
  <button onClick={handleAddField} className="btn btn-primary">
    Add
  </button>
</div>

</div>

    </div>
  );
};

export default function JsonTreeEditor({ data, onChange, title = "Json:" }) {
  return (
    <div>
      <h5 className="text-lg font-bold mb-2">{title}</h5>
      <TreeNode data={data} onChange={onChange} />
    </div>
  );
}
